import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { AmazingCoinsWinResourcePackage } from "../resources/AmazingCoinsWinResourcePackage";
import { GameFont } from "../../../common/GameFont";
import { StringFormatExtention } from "../../../../../extensions/StringFormatExtention";

export class AmazingWinCoinsRewardContainer extends Container {
    private readonly resources: AmazingCoinsWinResourcePackage;
    private rewardIcon: Sprite;
    private wonText: Sprite;
    private rewardValue: number;

    public constructor(resources: AmazingCoinsWinResourcePackage, rewardValue: number) {
        super();
        this.resources = resources;
        this.rewardValue = rewardValue;
        this.build();
    }

    private build(): void {
        const rewardValueText = new Text(StringFormatExtention.formatWithComma(this.rewardValue), new AmazingWinCoinsRewardValueTextStyle());
        rewardValueText.anchor.set(0.5, 0.5);
        rewardValueText.position.y = 10;
        this.addChild(rewardValueText);
        this.rewardIcon = new Sprite(this.resources.assets_views_amazing_win_popup_coin_icon_png);
        this.rewardIcon.anchor.set(0.5, 0.5);
        this.rewardIcon.position.x = rewardValueText.x + rewardValueText.width * 0.5 + this.rewardIcon.width * 0.6;
        this.addChild(this.rewardIcon);
        this.wonText = new Sprite(this.resources.assets_views_amazing_win_popup_you_won_png);
        this.wonText.anchor.set(0.5, 0.5);
        this.wonText.position.x = this.rewardIcon.width * 0.5;
        this.wonText.position.y = rewardValueText.y - rewardValueText.height * 0.5 - this.wonText.height;
        this.addChild(this.wonText);
    }
}

class AmazingWinCoinsRewardValueTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#e69006",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            stroke: "#ffffff",
            fontSize: 200,
            miterLimit: 0,
            strokeThickness: 8
        }));
    }
}